import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ClCardContent extends Vue {
  /**
   * The root component tag.
   */
  @Prop({
    default: 'div',
    type: String
  })
  public component!: string;

  /**
   * Disable the spacing of the actions.
   */
  @Prop({
    default: false,
    type: Boolean
  })
  public disableActionSpacing!: boolean;
}
